module.exports = __webpack_public_path__ + "static/media/sign.8d6d3bd6.svg";